import layout from '@/layout'

export default {
  path: '/pre_close_out',
  component: layout,
  redirect: '/pre_close_out/page5',
  name: 'pre_close_out_page5',
  meta: {
    title: 'pre_close_out',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_out/page5',
      name: 'pre_close_out_page5',
      component: () => import('@/views/pre_settle/pre_close/out/index5'),
      meta: {
        title: 'pre_close_out_page5',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
